/*
 * newsbot - Tag action component
 */

import { FilterSection, FilterLayout } from "@/components/filters/_components";
import { TextAreaAutoResize } from "@components/inputs";

interface TagProps {
  idx: number;
}

export const Tag = ({ idx }: TagProps) => (
  <FilterSection
    title="Tags"
    subtitle="Add tags to stories that match this filter"
  >
    <FilterLayout>
      <TextAreaAutoResize
        name={`actions.${idx}.tags_to_add`}
        label="Tags to Add"
        placeholder="breaking, urgent, crypto"
        tooltip={
          <div>
            <p>Comma-separated list of tags to add to matching stories.</p>
          </div>
        }
      />
    </FilterLayout>
  </FilterSection>
);
